var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4223 1.32113C16.9288 0.427227 16.3931 0.262804 15.3025 0.200277C14.2131 0.125013 11.4735 0.09375 9.1001 0.09375C6.72216 0.09375 3.98144 0.125013 2.89311 0.199119C1.80478 0.262804 1.26801 0.426069 0.769904 1.32113C0.261562 2.21387 0 3.75157 0 6.45875C0 6.46107 0 6.46223 0 6.46223C0 6.46454 0 6.4657 0 6.4657V6.46802C0 9.16362 0.261562 10.7129 0.769904 11.5964C1.26801 12.4903 1.80364 12.6524 2.89197 12.7277C3.98144 12.7925 6.72216 12.8307 9.1001 12.8307C11.4735 12.8307 14.2131 12.7925 15.3037 12.7288C16.3943 12.6535 16.9299 12.4914 17.4235 11.5975C17.9364 10.7141 18.1957 9.16478 18.1957 6.46918C18.1957 6.46918 18.1957 6.4657 18.1957 6.46339C18.1957 6.46339 18.1957 6.46107 18.1957 6.45991C18.1957 3.75157 17.9364 2.21387 17.4223 1.32113Z",
    fill: "#E93F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67188 10.4033V3.125L12.1306 6.76413L6.67188 10.4033Z",
    fill: "#FAFAFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.37bcb34299d340e863236185722ba05b.svg";
export { ForwardRef as ReactComponent };